/* eslint-disable */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseHttpService, ResourceHelper} from '../util/http-services';
import {HttpClient} from '@angular/common/http';
import {ResourceQueryResult} from '../util/services';
import {DownloadedFile} from '../util/downloaded-files';
import {map} from 'rxjs/operators';
import {DqlStoredQueryResourceService} from '../dql/dql-stored-query-resource.service';
import {CustomerRecordResource} from "../customer/customer-record-resource.service";
import {EmptyMessage} from "../util/messages";

/* eslint-enable */

@Injectable()
export class ClientDocumentResourceService extends BaseHttpService {
  private static readonly baseUrl = '/client-document/';

  private readonly _dqlStoredResourceService: DqlStoredQueryResourceService;

  get dqlStoredResourceService(): DqlStoredQueryResourceService {
    return this._dqlStoredResourceService;
  }

  query(request: ClientDocumentResource.QueryRequest): Observable<ResourceQueryResult<ClientDocumentResource.ClientDocument>> {
    return this.http.get<ResourceQueryResult<ClientDocumentResource.ClientDocument>>(this.url, this.parseParams(request));
  }

  downloadPdf(request: ClientDocumentResource.DownloadPdfRequest): Observable<DownloadedFile> {
    return this.http.get(this.url + `${request.document_type}/` + request.id + '/pdf/download', {
      observe: 'response',
      responseType: 'blob',
    }).pipe(map((res) => {
      return new DownloadedFile(res);
    }));
  }

  resendOfferEmail(request: ClientDocumentResource.ResendRequest): Observable<EmptyMessage> {
    return this.http.post<EmptyMessage>(this.url + `${request.document_type}/resend-offer`,request);
  }

  downloadZip(request: ClientDocumentResource.QueryRequest): Observable<DownloadedFile> {
    return this.http.get(this.url + `/pdf/download-zip`, {
      observe: 'response',
      responseType: 'blob',
      params: this.parseParams(request).params
    }).pipe(map((res) => {
      return new DownloadedFile(res);
    }));
  }

  downloadMergedZip(request: ClientDocumentResource.QueryRequest): Observable<DownloadedFile> {
    return this.http.get(this.url + `/pdf/download-merged-zip`, {
      observe: 'response',
      responseType: 'blob',
      params: this.parseParams(request).params
    }).pipe(map((res) => {
      return new DownloadedFile(res);
    }));
  }

  constructor(private http: HttpClient, resourceHelper: ResourceHelper) {
    super(resourceHelper, ClientDocumentResourceService.baseUrl);
    this._dqlStoredResourceService = new DqlStoredQueryResourceService(
      http, resourceHelper, ClientDocumentResourceService.baseUrl
    );
  }

}

export namespace ClientDocumentResource {

  export interface ClientDocument {
    id: string,
    document_type: string,
    external_id: string,
    offer_id?: string,
    state: string,
    customer_record_id?: number,
    task_record_id?: number,
    creator_user_id: number,
    last_editor_user_id: number,
    submitter_user_id?: number,
    offer_user_id?: number,
    creation_time: string,
    update_time: string,
    submit_time: string,
    offer_time: string,
    pdf_id?: number,
    version?: ElasticVersion,
    form: ClientDocumentForm
  }

  export interface ElasticVersion {
    seq_no: number,
    primary_term: number
  }

  export interface ClientDocumentForm {
    insurance_product?: ClientDocumentFormInsuranceProductDictionary;
    insurance_type?: ClientDocumentFormImageDictionary;
    payment_type?: ClientDocumentFormImageDictionary;
    insurance_level?: ClientDocumentFormInsuranceLevel;
    sponsor?: ClientDocumentFormImageDictionary;
    deletion_date?: string,
    deletion_cause?: string
  }

  export interface ObjectWithText {
    text?: string;
    code?: string;
  }

  export interface ClientDocumentFormImageDictionary extends ObjectWithText {
    image_code?: string;
  }

  export interface ClientDocumentFormInsuranceProductDictionary extends ClientDocumentFormImageDictionary {
    external_id_prefix?: string;
  }

  export interface ClientDocumentFormInsuranceLevel {
    level?: number;
    code?: string;
    price?: number;
    discounted_price?: number;
  }

  export interface ClientDocumentFormSponsorDiscount {
    sponsor_code?: string;
    product_code?: string;
    discount_forint?: number;
    discount_percent?: number;
  }

  export interface ClientDocumentFormVipDiscount {
    discount_percent?: number;
  }

  export interface CustomerRecord extends CustomerRecordResource.CustomerRecord {
    employee_id?: string;
    number_of_children?: number;
    beneficiary_rate?: number;
}

  export interface ColonnadeInsurance1ClientDocumentForm extends ClientDocumentForm {
    insurance_product?: ClientDocumentFormInsuranceProductDictionary;
    insurance_type?: ClientDocumentFormImageDictionary;
    payment_type?: ClientDocumentFormImageDictionary;
    insurance_level?: ClientDocumentFormInsuranceLevel;
    sponsor?: ClientDocumentFormImageDictionary;
    branch?: ClientDocumentFormImageDictionary;
    contracting_customer_record?: CustomerRecord;
    beneficiary_customer_records?: CustomerRecord[];
    sponsor_discount?: ClientDocumentFormSponsorDiscount;
    vip_discount?: ClientDocumentFormVipDiscount;
    insured_customer_record?: CustomerRecord;
    bank_account_number?: string;
    contact_type?: ClientDocumentFormImageDictionary;
    personal_information_provided?: ObjectWithText;
    gathering_personal_information_approved?: ObjectWithText;
    marketing_research_approved?: ObjectWithText;
    home_insurance_interested?: ObjectWithText;
    contracting_signature?: string;
    insurer_signature?: string;
  }

  export interface DownloadPdfRequest {
    id: string;
    document_type: string;
  }

  export interface QueryRequest {
    ids?: string;
    document_type?: string;
    submitted_only?: boolean;
    offer_only?: boolean;
    dql?: string;
    order?: string;
    page_number?: number;
    number_of_items?: number;
  }

  export interface ResendRequest {
    ids: string[];
    document_type: string;
  }

}
